<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="38" viewBox="0 0 25 38" width="25" xmlns="http://www.w3.org/2000/svg"><g :fill="color"><path d="m12.4591 38c-.5913 0-6.44601 0-6.99505 0 0-.2344-.00264-.5125 0-.7853.01451-1.3602.02639-2.7229.13989-4.0764.16102-1.9217.41442-3.8354.62823-5.7531.20986-1.8819.70875-3.7016 1.27892-5.4948.75361-2.3693 1.7989-4.6021 3.34441-6.5847.9437-1.2105 1.9652-2.3243 3.2243-3.2076 1.667-1.1708 3.454-2.066 5.435-2.58916 1.366-.36023 3.2798-.68073 4.1469-.67411.3788.00265.8856-.00529 1.3383-.00529 0 .30328-.0079.57213-.0079.84759 0 1.79057.0092 3.58107.0013 5.37167 0 .2277.0053.4516.0053.731-.3194.0199-.6718.0384-.9292.053-1.1918.0675-2.3598.2675-3.4869.6675-1.8979.6714-3.4276 1.8263-4.5257 3.5294-.8948 1.3879-1.5864 2.8686-2.0378 4.4631-.586 2.0687-.9503 4.1704-1.1918 6.3106-.2441 2.164-.3365 4.3267-.3643 6.4973-.0026.2331-.0066.494-.0066.6993z"/><path d="m25 0h-25v7.00456h25z"/></g></svg>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/7.vue